import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { ConfigStateService, PermissionService } from '@abp/ng.core';
import { CustomService } from '@proxy/custom.service';
import { MENU } from './menu';
import { MenuItem } from './menu.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  menu: any;
  toggle: any = true;
  menuItems: MenuItem[] = [];
  menus: MenuItem[] = [];
  removeIds = [];
  addIds = [];
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  isMenuOpen = false;
  isDefaultSideBar = false;
  routeName = 'nextere';
  userInfoType: any;
  decodetoken: any;
  currentUserDetails: any;
  userData;
  constructor(
    private readonly router: Router,
    private readonly permissionService: PermissionService,
    private readonly config: ConfigStateService,
    private readonly customService: CustomService,
  ) {
  }
  ngOnInit(): void {
    // this.routeName = localStorage.getItem('route');
    // Menu Items
    this.menuItems = MENU;
    this.menus = this.menuItems
      .map(item => this.shouldIncludeMenuItem(item) ? item : null)
      .filter(Boolean);
    this.router.events.subscribe(event => {
      if (document.documentElement.getAttribute('data-layout') != 'twocolumn') {
        if (event instanceof NavigationEnd) {
          this.initActiveMenu();
        }
      }
    });
  }

private isFeatureEnabled(feature: string | string[]): boolean {
  if (!feature) return true;

  if (Array.isArray(feature)) {
    return feature.some(f => this.config.getFeature(f) === 'true');
  }

  return this.config.getFeature(feature) === 'true';
}
  private isPermissionGranted(permission: string): boolean {
    if (permission == 'default') {
        return true;
      }
    return !permission || this.permissionService.getGrantedPolicy(permission);
  }

  private shouldIncludeItemById(item: any): boolean {
    return true;
  }

  private filterSubItems(subItems: any[]): any[] {
    return subItems
      .map(subItem => {
         if (!this.isFeatureEnabled(subItem.feature ?? subItem.features)) return null;
        if (!this.isPermissionGranted(subItem.permission)) return null;

        if (subItem.subItems) {
          subItem.subItems = this.filterSubItems(subItem.subItems);
        }

        return subItem;
      })
      .filter(Boolean);
  }

  private shouldIncludeMenuItem(item: any): boolean {
    if (!this.shouldIncludeItemById(item)) {
      return false;
    }

    if (!this.isFeatureEnabled(item.feature)) {
      return false;
    }

    if (!this.isPermissionGranted(item.permission)) {
      return false;
    }

    if (item.subItems) {
      item.subItems = this.filterSubItems(item.subItems);
    }

    return true;
  }
  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.initActiveMenu();
    }, 0);
  }
  removeActivation(items: any) {
    items.forEach((item: any) => {
      item.classList.remove('active');
    });
  }
  toggleItem(item: any) {
    this.menuItems.forEach((menuItem: any) => {
      if (menuItem == item) {
        menuItem.isCollapsed = !menuItem.isCollapsed;
      } else {
        menuItem.isCollapsed = true;
      }
      if (menuItem.subItems) {
        menuItem.subItems.forEach((subItem: any) => {
          if (subItem == item) {
            menuItem.isCollapsed = !menuItem.isCollapsed;
            subItem.isCollapsed = !subItem.isCollapsed;
          } else {
            subItem.isCollapsed = true;
          }
          if (subItem.subItems) {
            subItem.subItems.forEach((childitem: any) => {
              if (childitem == item) {
                childitem.isCollapsed = !childitem.isCollapsed;
                subItem.isCollapsed = !subItem.isCollapsed;
                menuItem.isCollapsed = !menuItem.isCollapsed;
              } else {
                childitem.isCollapsed = true;
              }
              if (childitem.subItems) {
                this.toggleSubItem(childitem.subItems, item, childitem, subItem, menuItem)

              }
            });
          }
        });
      }
    });
  }

  toggleSubItem(subItems, item, childitem, subItem, menuItem) {
    subItems.forEach((childrenitem: any) => {
      if (childrenitem == item) {
        childrenitem.isCollapsed = false;
        childitem.isCollapsed = false;
        subItem.isCollapsed = false;
        menuItem.isCollapsed = false;
      } else {
        childrenitem.isCollapsed = true;
      }
    });
  }
  activateParentDropdown(item: any) {
    item.classList.add('active');
    let parentCollapseDiv = item.closest('.collapse.menu-dropdown');
    if (parentCollapseDiv) {
      parentCollapseDiv.parentElement.children[0].classList.add('active');
      if (parentCollapseDiv.parentElement.closest('.collapse.menu-dropdown')) {
        if (parentCollapseDiv.parentElement.closest('.collapse').previousElementSibling)
          parentCollapseDiv.parentElement
            .closest('.collapse')
            .previousElementSibling.classList.add('active');
        if (
          parentCollapseDiv.parentElement
            .closest('.collapse')
            .previousElementSibling.closest('.collapse')
        ) {
          parentCollapseDiv.parentElement
            .closest('.collapse')
            .previousElementSibling.closest('.collapse')
            .previousElementSibling.classList.add('active');
        }
      }
      return false;
    }
  }
  updateActive(event: any) {
    const ul = document.getElementById('navbar-nav');
    if (ul) {
      const items = Array.from(ul.querySelectorAll('a.nav-link'));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
  }
  initActiveMenu() {
    let pathName = window.location.pathname;
    const active = this.findMenuItem(pathName, this.menuItems);
    this.toggleItem(active);
    const ul = document.getElementById('navbar-nav');
    if (ul) {
      const items = Array.from(ul.querySelectorAll('a.nav-link'));
      let activeItems = items.filter((x: any) => x.classList.contains('active'));
      this.removeActivation(activeItems);
      let matchingMenuItem = items.find((x: any) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }
  private findMenuItem(pathname: string, menuItems: any[]): any {
    let updatedPathName: string;
    if (pathname.includes(this.routeName)) {
      updatedPathName = pathname?.split(this.routeName)[1]
    } else {
      updatedPathName = pathname
    }
    for (const menuItem of menuItems) {
      if (menuItem.link && menuItem.link === updatedPathName) {
        return menuItem;
      }
      if (menuItem.subItems) {
        const foundItem = this.findMenuItem(updatedPathName, menuItem.subItems);
        if (foundItem) {
          return foundItem;
        }
      }
    }
    return null;
  }
  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    let sidebarsize = document.documentElement.getAttribute('data-sidebar-size');
    if (sidebarsize == 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    }
  }
  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    document.body.classList.remove('vertical-sidebar-enable');
  }
  navigateToRoute(item) {
    this.router.navigate(['/' + localStorage.getItem('route') + item.link]);
  }
}